import React from 'react';
import styled from "styled-components";
import { Button } from "../../features/shared";
import { useNavigate } from "react-router-dom";
import { Subtitle, Title } from "../../styles/text";
import { Message } from "../../locale/Message";
import { useDispatch, useSelector } from "react-redux"
import { getTariff, getBrand } from '../../store/mainPageReducer';
import { Loader } from '../../ui';

const BtnRoot = styled.div`
		margin-top: 80px;
		button {
				margin-bottom: 8px;
		}
    @media screen and (max-width: 640px) {
        margin-top: 40px;
    }
`

const MainRoot = styled.div`
    margin-top: 120px;
	
	h1 {
		min-height: 73px;
	}
    @media screen and (max-width: 640px) {
		min-height: 363px;
    }
`

const LoaderWrapper = styled.div`
    display: flex;
	justify-content: center;
	align-items: center;
	min-height: 403px;
	@media screen and (max-width: 640px) {
		min-height: 363px;
    }
`

const Main = ({ lang }) => {
	let navigate = useNavigate();
	const dispatch = useDispatch()
	const brand = useSelector((state) => state.mainPage.brand);
	const loading = useSelector((state) => state.mainPage.loading);

	function checkBrand(brand) {
		brand === "ACTIV" && navigate('/activ')
		brand === "KCELL" && navigate('/kcell')
		brand === "OTHER" && navigate("/")
		brand !== "ACTIV" && brand !== "KCELL" && brand !== "OTHER" && navigate("/")
	}

	React.useEffect(() => {
		dispatch(getTariff()).unwrap()
			.then((res) => {
				if (res.isAulet === true) {
					navigate('/aulet')
				} else {
					dispatch(getBrand())
				}

				return res.isAulet;
			})
			.catch(() => {
				dispatch(getBrand());
			})
	}, [])

	React.useEffect(() => {
		checkBrand(brand)
	}, [brand])

	return (
		<MainRoot>
			{loading ? (
				<LoaderWrapper>
					<Loader />
				</LoaderWrapper>
			) : (
				<>
					<Title>
						{Message.mainTitle[lang]}
					</Title>
					<Subtitle>
						{Message.mainSubtitle[lang]}
					</Subtitle>
					<BtnRoot>
						<Button onClick={() => navigate('/activ')} text="Activ" type="activ" />
						<Button onClick={() => navigate('/kcell')} text="Kcell" type="kcell" />
						<Button onClick={() => navigate('/aulet')} text="Aulet" type="aulet" />
					</BtnRoot>
				</>
			)}
		</MainRoot>
	);
};

export default Main;
